import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import './CommentWrapper.css';

const StyledCommentWrapper = styled.div`
  z-index: ${({ isReply, repliesCollapsed, zIndex }) => {
    if (isReply) {
      // Ensures hidden replies don't mess
      // with the z-index of the comments being shown
      return repliesCollapsed ? 0 : zIndex;
    }
    return zIndex;
  }};
`;

const getStyleName = ({ isReply, isDeleted, collapse, collapseActive }) => {
  let style = '';
  switch (true) {
    case isReply && isDeleted:
      style = 'wrapper-deleted-reply';
      break;
    case isReply:
      style = 'wrapper-reply';
      break;
    case isDeleted:
      style = 'wrapper-deleted';
      break;
    default:
      style = 'wrapper';
  }
  if (collapse) {
    style = `${style} collapse-${collapseActive ? 'hide' : 'show'}`;
  }
  return style;
};

const CommentWrapper = ({
  children,
  isReply,
  isDeleted,
  hasRepliesCollapse,
  repliesCollapsed,
  id,
  zIndex
}) => {
  return (
    <StyledCommentWrapper
      zIndex={zIndex}
      name={`comment-${id}`}
      repliesCollapsed={repliesCollapsed}
      isReply={isReply}
      styleName={getStyleName({
        isReply,
        isDeleted,
        collapse: hasRepliesCollapse,
        collapseActive: repliesCollapsed
      })}
    >
      {children}
    </StyledCommentWrapper>
  );
};

CommentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isReply: PropTypes.bool,
  isDeleted: PropTypes.bool,
  hasRepliesCollapse: PropTypes.bool,
  repliesCollapsed: PropTypes.bool,
  id: PropTypes.number.isRequired,
  zIndex: PropTypes.number
};

CommentWrapper.defaultProps = {
  isReply: false,
  isDeleted: false,
  hasRepliesCollapse: false,
  repliesCollapsed: false,
  zIndex: null
};

export default CommentWrapper;
